import { APIClient } from '../../utils/APIClient';
import { API_URL } from '../../settings/local_settings';


export class KnewsService {
    static getUnreadCount() {
        return new APIClient(API_URL + 'knews/unread-count/').call('GET');
    }

    static list(page = 1, pageSize = 20) {
        return new APIClient(
            API_URL + `knews/?page=${page}&page_size=${pageSize}`
        ).call('GET');
    }

    static markSeen(id) {
        return new APIClient(API_URL + `knews/${id}/mark-seen/`).call('POST');
    }

    static markAllSeen() {
        return new APIClient(API_URL + 'knews/mark-all-seen/').call('POST');
    }

    static trackClick(id) {
        return new APIClient(API_URL + `knews/${id}/track-click/`).call('POST');
    }
}
